import { render } from "./FinancialPage.vue?vue&type=template&id=0bdab484&scoped=true&ts=true"
import script from "./FinancialPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./FinancialPage.vue?vue&type=script&lang=ts&setup=true"

import "./FinancialPage.vue?vue&type=style&index=0&id=0bdab484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdab484"],['__file',"src/pages/financial/FinancialPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bdab484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bdab484', __exports__)) {
    api.reload('0bdab484', __exports__)
  }
  
  module.hot.accept("./FinancialPage.vue?vue&type=template&id=0bdab484&scoped=true&ts=true", () => {
    api.rerender('0bdab484', render)
  })

}


export default __exports__